import { AlertCircle, CheckCircle2, LockKeyhole } from 'lucide-react'
import { StatusPill } from '@/components/status-pill'
import { cn } from '@/lib/utils'
import type { QuoteStatus, WorkflowStageStatus } from '../api/types'
import { quoteStatusLabels, quoteStatusTones } from './status-labels'

/** A quote's status in the dashboard's shared `StatusPill`. */
export function QuoteStatusPill({ status, className }: { status: QuoteStatus; className?: string }) {
  return (
    <StatusPill className={className} tone={quoteStatusTones[status]}>
      {quoteStatusLabels[status]}
    </StatusPill>
  )
}

/** Workflow stage mark: complete, needs attention, or locked until an earlier stage is done. */
export function StageMark({ status, className }: { status: WorkflowStageStatus; className?: string }) {
  if (status === 'complete') {
    return <CheckCircle2 aria-hidden="true" className={cn('size-4 shrink-0 text-emerald-600', className)} />
  }
  if (status === 'unavailable') {
    return <LockKeyhole aria-hidden="true" className={cn('size-4 shrink-0 text-muted-foreground', className)} />
  }
  return <AlertCircle aria-hidden="true" className={cn('size-4 shrink-0 text-amber-600', className)} />
}
